export const READINESS_STATUS = {
  READY: 'ready',
}

export const ASSET_STATUS = {
  FUNCTIONAL:     'functional',
  MAINTENANCE:    'maintenance',
  OUT_OF_SERVICE: 'outOfService',
}

export const ROADBLOCK_STATUS = {
  OPEN:     'open',
  RESOLVED: 'resolved',
}

export const MOVE_STATUS = {
  PENDING:   'pending',
  COMPLETE:  'complete',
  COMPLETED: 'completed',
}

export const MEMBER_STATUS = {
  ACTIVE:   'active',
  SICK:     'sick',
  TRAINING: 'training',
}
